import { render, staticRenderFns } from "./DvError.vue?vue&type=template&id=7b06f380&scoped=true&"
import script from "./DvError.vue?vue&type=script&lang=ts&"
export * from "./DvError.vue?vue&type=script&lang=ts&"
import style0 from "./DvError.vue?vue&type=style&index=0&id=7b06f380&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b06f380",
  null
  
)

export default component.exports